import toast from 'jquery-toast-plugin';

/*
 * continuous click
 */
jQuery(function ($) {
	// form二度押し防止
	var iClickCount = 0;
	$(document).on('submit', 'form:not(.available-continuous-click)', function () {
		if (iClickCount == 0) {
			iClickCount = 1;
		} else {
			alert('ただいま処理中です。OKを押してそのままお待ちください。');
			return false;
		}
	});
});

/*
 * テキストエリアを自動リサイズ
 */
jQuery(function ($) {
	if ($('.autosize').length > 0 && $('.autosize.js-message-textarea-1000').length == 0  ) {
		autosize($('.autosize'));
	}
});

/*
 * 郵便番号から住所読み込み
 */
jQuery(function ($) {
	if ($('.zip-code.selectbox-city').length > 0) {
		$(document).on(oEventNames.end, '.load-address', function (event) {
			if (!bIsScrolling) {
				event.preventDefault();
				// jpostalは、市区町村selectboxに対応していないため、別APIを利用
				var sUrl = 'https://api.zipaddress.net?callback=?';
				var oQuery = { 'zipcode': $('.zip-code.selectbox-city').val() };
				$.getJSON(sUrl, oQuery, function (oResponse) {
					// 都道府県選択
					$('.link-city.state-id option').filter(function (index) {
						return $(this).text() === oResponse.pref;
					}).prop('selected', true);
					// 市区町村読み込み＋市区選択
					sSelectCity = oResponse.city;
					$(".link-city.state-id").trigger("change");
					// 町村入力
					$('.input-address').val(oResponse.town);
				});
			}
		});
	} else if ($('.zip-code').length > 0) {
		$('.zip-code').jpostal({
			click: '.load-address',
			postcode: [
				'.zip-code'
			],
			address: {
				'.state-id': '%3',
				'.input-address': '%4%5'
			}
		});
	}
});

/*
 * ファイル選択（boostrap）
 */
jQuery(function ($) {
	// ファイル名を表記
	$(".custom-file-input").on("change", function () {
		var sFileName = $(this).val().split("\\").pop();
		$(this).siblings(".custom-file-label").addClass("selected").html(sFileName);
	});
	// ファイルの取消
	$('.custom-file-input-reset').click(function () {
		var iNumber = $(this).data('number');
		$('.input-number' + iNumber).next('.custom-file-label').html('ファイル選択...');
		$('.input-number' + iNumber).val('');
	})
	$('.js-custom-file').on(oEventNames.end,function (event) {
		if (!bIsScrolling) {
			event.preventDefault();
			var iNumber = $(this).attr('data-id');
			$('.input-number' + iNumber).next('.custom-file-label').html('ファイル選択...');
			$('#file_path' + iNumber).val('');
		}
	})
});

/*
 * チェックボックス選択数制限
 */
jQuery(function ($) {
	if ($('.checkbox-limit-count').length > 0) {
		setCheckBoxDisabled();
		$(".checkbox-limit-count input[type=checkbox]").click(function () {
			setCheckBoxDisabled();
		});
		function setCheckBoxDisabled() {
			$('.checkbox-limit-count').each(function (i, elem) {
				var iAvailableCheckCount = $(elem).data('limit-count');
				var iCount = $(elem).find('input[type=checkbox]:checked').length;
				var $oNotCheckedInput = $(elem).find('input[type=checkbox]').not(':checked');
				if (iCount >= iAvailableCheckCount) {
					$oNotCheckedInput.attr("disabled", true);
				} else {
					$oNotCheckedInput.attr("disabled", false);
				}
			});
		}
	}
});

$(function () {
	// ▼※を必須マークに変換
	if ($('.mypage, .login-signup, .main.request-form, form.form-simple').length > 0) {
		$('label').each(function () {
			let dataname = $(this).html();
			let brank = "※";
			let regExp = new RegExp(brank, "g");
			let name = dataname.replace(regExp, '<span class="required">必須</span>');
			$(this).html(name);
		});
	};
	if ($('.mypage-list-item').length) {
		$('.mypage-list-item').each(function () {
			let link = $(this).children('a').attr('href');
			let url = location.href;
			if (link == url) {
				$(this).children('a').addClass('active');
			}
		});
	};
});

// autosize
autosize($('.autosize'));

// ファイル選択
$(document).on(oEventNames.end, '.input-group-append .delete-btn', function (event) {
  $(this).parent('.input-group-append').prev('.custom-file').find('.custom-file-label').removeClass('selected').text('ファイル選択...');
  $(this).parent('.input-group-append').prev('.custom-file').find('input[type="file"]').val('');
});

// タクシー券の利用額
$(function() {
	if($("input[name='taxi_ticket_amount']").length) {

		// お迎え先情報登録ajax
			$("input[name='taxi_ticket_amount']").on('input',function() {
				console.log('aaa');
				if($(this).val() > 100000) {
					if($('.help-block.js-taxi_amount').length == 0) {
						$('.js-flg_taxi_ticket').append('<span class="help-block js-taxi_amount">タクシー券の利用額は10万円以下で設定くださいませ。</span>');
					}
				}else{
					$('.js-taxi_amount').remove();
				}
			});
	}
});